import { defineMessages } from 'react-intl';

export const messages = {
  title: {
    id: 'app.switchedTenant.title',
    defaultMessage: 'Switched organization',
    description: 'The title of the switched tenant dialog',
  },
  message: {
    id: 'app.switchedTenant.message',
    defaultMessage:
      "You switched to another organization in a different window. Click on the 'Ok' button below, to switch to this organization.",
    description: 'The message of the switched tenant dialog',
  },
  actions: {
    ok: {
      id: 'app.switchedTenant.actions.ok',
      defaultMessage: 'Ok',
      description: 'The label of the switch action button of the switched tenant dialog',
    },
  },
};

export default defineMessages(messages);
